const plannedCopyReplacements: Array<[RegExp, string]> = [
  [/^Poslaný report(?=\s|$)/i, "Poslať report"],
  [/^Odoslaný report(?=\s|$)/i, "Poslať report"],
  [/^Report odoslaný(?=\s|$)/i, "Poslať report"],
  [/^Klient kontaktovaný(?=\s|$)/i, "Kontaktovať klienta"],
  [/^Reakcia trhu vyhodnotená(?=\s|$)/i, "Vyhodnotiť reakciu trhu"],
  [/^Follow-up (?:dokončený|vybavený)(?=\s|$)/i, "Urobiť follow-up"]
];

export const normalizePlannedActionCopy = (value: string) => {
  const trimmed = value.trim().replace(/[.\s]+$/, "");
  return plannedCopyReplacements.reduce(
    (result, [pattern, replacement]) => result.replace(pattern, replacement),
    trimmed
  );
};
